module.exports = __webpack_public_path__ + "static/media/GoogleDrive.da433173.png";